interface HeatingControlProps {
  heating: boolean;
  isOn: boolean;
  tempLevel: number;
  onToggle: () => void;
  onTempLevelChange: (v: number) => void;
}

const HEAT_LEVELS = [
  { value: 38, label: "低温" },
  { value: 42, label: "中温" },
  { value: 46, label: "高温" },
];

export default function HeatingControl({
  heating,
  isOn,
  tempLevel,
  onToggle,
  onTempLevelChange,
}: HeatingControlProps) {
  return (
    <div className="rounded-xl border border-background-200 bg-background-100/60 p-3">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
          <i className="ri-fire-line text-accent-500" /> 加熱
        </span>
        <button
          type="button"
          onClick={onToggle}
          disabled={!isOn}
          aria-label="加熱のオンオフ"
          className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${
            !isOn ? "cursor-not-allowed opacity-40" : "cursor-pointer"
          } ${heating ? "bg-accent-500" : "bg-background-300"}`}
        >
          <span
            className={`absolute top-0.5 h-5 w-5 rounded-full bg-background-50 transition-all ${
              heating ? "left-[22px]" : "left-0.5"
            }`}
          />
        </button>
      </div>

      <div
        className={`mt-2 overflow-hidden transition-all duration-200 ${
          heating && isOn ? "max-h-20 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="flex gap-1.5 overflow-hidden">
          {HEAT_LEVELS.map((l) => (
            <button
              key={l.value}
              type="button"
              onClick={() => onTempLevelChange(l.value)}
              disabled={!isOn}
              className={`flex-1 cursor-pointer whitespace-nowrap rounded-md py-1.5 text-xs font-medium transition-colors ${
                tempLevel === l.value
                  ? "bg-accent-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:bg-background-200"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}